import React from 'react'
import { GlobalContext } from '../../../Global/GlobalContext';
import { Div } from './styles';
import { ReactComponent as Loading} from '../../../Assets/img/load/load-2.svg';

const LoaderPage = () => {
    const {loading} = React.useContext(GlobalContext);

    if(!loading) return null;

    return (
        <Div >
            <div className="load">
                <Loading />
            </div>
        </Div>
    )
}

export default LoaderPage
